module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_08.d95c9431.svg";